export default __webpack_public_path__ + "static/media/s2c3.12698db8.jpg";